export enum Formulaire_Reponse_Statut {
    Envoyee,
    ValideParDirection,
    EnCoursDeTraitement,
    Traitee
}

export function Formulaire_Reponse_Statut_ToText(input: Formulaire_Reponse_Statut) {
    switch (input) {
        case Formulaire_Reponse_Statut.EnCoursDeTraitement:
            return 'En cours'
        case Formulaire_Reponse_Statut.ValideParDirection:
            return 'Validé par la direction'
        case Formulaire_Reponse_Statut.Envoyee:
            return 'Nouveau'
        case Formulaire_Reponse_Statut.Traitee:
            return 'Traité'
    }
}
